import { createChildListViewComponent } from 'factories/ChildListView'
import entityNames from 'options/entityNames'
import FormView from 'containers/Products/CustomerDetails/FormView'

export default createChildListViewComponent({
  entityName: entityNames.products,
  childName: 'customerDetails',
  createButtonTextId: 'addCustomerDetail',
  createButtonLinkTarget: {
    formSize: 'xs',
    formComponent: FormView,
  },
  primaryLinkTarget: 'customerDetailRecord',
})()
